<script>
import 'chartjs-adapter-moment'
import { Line, mixins } from 'vue-chartjs'
import ChartDataLabels from 'chartjs-plugin-datalabels'

/**
 * График - линия.
 */
export default {
  name: 'CLineChart',
  extends: Line,
  mixins: [mixins.reactiveProp],
  props: {
    chartData: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      required: true
    }
  },
  mounted () {
    this.addPlugin(ChartDataLabels)
    this.renderChart(this.chartData, this.options)
  }
}
</script>
